import React from "react";
import SmartScanSelfieCapture from "../SmartScanSelfieCapture/SmartScanSelfieCapture";
import { smartScanCategory } from "../../constants";
import useGetSmartScanSelfieCaptureProgress from "../CustomHooks/useGetSmartScanSelfieCaptureProgress";
import {
  getSmartScanImageBasedOnCaptureOption,
  getSmartScanInstructionsBasedOnCaptureOption
} from "../../helpers/smartScanUtils";

const SmartScanLowerArchPage = () => {
  const smartScanState = useGetSmartScanSelfieCaptureProgress();

  return (
    <>
      <SmartScanSelfieCapture
        state={smartScanState}
        previousPagePath={"/smart-scan-upper-arch-confirm"}
        nextPagePath={
          smartScanState?.isAuthenticated
            ? "/smart-scan-lower-arch-confirm"
            : "/smart-scan-lower-arch-confirm-no-auth"
        }
        category={smartScanCategory.LowerArch}
        poseImage={getSmartScanImageBasedOnCaptureOption(
          smartScanState?.captureOption,
          smartScanCategory.LowerArch
        )}
        instruction={getSmartScanInstructionsBasedOnCaptureOption(
          smartScanState?.captureOption,
          smartScanCategory.LowerArch
        )}
      />
    </>
  );
};

export default SmartScanLowerArchPage;
